if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends BaseElement {
      connectedCallback() {
        super.connectedCallback();

        this.errorHtml = this.errorHtml || this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.on(this, 'click', (event) => {
          if (event.target.closest('[data-pickup-retry]')) this.onClickRefreshList();
        });
        this.registerCleanup(() => {
          this.requestVersion++;
          this.availabilityAbortController?.abort();
          this.drawer?.remove();
        });
        this.fetchAvailability(this.getAttribute('data-variant-id'));
      }

      fetchAvailability(variantId) {
        this.setAttribute('data-variant-id', String(variantId));
        const version = this.requestVersion = (this.requestVersion || 0) + 1;
        this.stockState = 'pending';
        this.stock = null;
        this.renderStock();
        this.checkStock(variantId, version);

        let rootUrl = this.getAttribute('data-root-url');
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        this.availabilityAbortController?.abort();
        this.availabilityAbortController = new AbortController();

        fetch(variantSectionUrl, { signal: this.availabilityAbortController.signal })
          .then((response) => {
            if (!response.ok) throw new Error('Pickup request failed');
            return response.text();
          })
          .then((responseText) => {
            if (version !== this.requestVersion) return;
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((error) => {
            if (error.name === 'AbortError' || version !== this.requestVersion) return;

            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.getAttribute('data-variant-id'));
      }

      async checkStock(variantId, version) {
        try {
          const client = window.theme?.shippingAvailability?.client;
          if (!client) throw new Error('Stock check unavailable');
          const stock = await client.get(variantId, { force: true });
          if (version !== this.requestVersion) return;
          this.stock = stock;
          this.stockState = 'checked';
        }
        catch {
          if (version !== this.requestVersion) return;
          this.stockState = 'error';
        }
        this.renderStock();
      }

      pickupState(row) {
        if (row.dataset.nativeAvailable !== 'true') return 'unavailable';
        const sourceId = window.theme?.shippingAvailabilityConfig?.pickupStockLocationId;
        if (!sourceId || row.dataset.locationId !== sourceId || row.dataset.inventoryTracked !== 'true') return 'error';
        if (this.stockState !== 'checked') return this.stockState || 'pending';
        return this.stock?.available && !this.stock.backorder ? 'available' : 'unavailable';
      }

      renderStock() {
        const variantId = this.getAttribute('data-variant-id');
        for (const root of [this, this.drawer].filter(Boolean)) {
          for (const row of root.querySelectorAll('[data-pickup-stock]')) {
            const state = row.dataset.variantId === variantId ? this.pickupState(row) : 'pending';
            for (const view of row.querySelectorAll('[data-pickup-state]')) {
              view.hidden = view.dataset.pickupState !== state;
            }
            const details = row.closest('.pickup-availability-preview')?.querySelector('[data-pickup-details]');
            if (details) details.hidden = state !== 'available';
          }
        }
      }

      update(variant) {
        if (variant?.id) {
          this.fetchAvailability(variant.id);
        }
        else {
          this.requestVersion++;
          this.availabilityAbortController?.abort();
          this.drawer?.remove();
          this.innerHTML = '';
          this.removeAttribute('available');
          this.setAttribute('hidden', '');
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('.pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('.pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          this.setAttribute('hidden', '');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-preview').outerHTML;
        this.removeAttribute('hidden');
        this.setAttribute('available', '');

        this.drawer = sectionInnerHTML.querySelector('.pickup-availability-drawer');
        if (this.drawer) {
          document.body.appendChild(this.drawer);
          this.on(this.drawer, 'click', (event) => {
            if (event.target.closest('[data-pickup-retry]')) this.onClickRefreshList();
          });
        }
        this.renderStock();
      }
    }
  );
}
